const features = [
  {
    icon: 'ri-device-line',
    title: '多端同步观看',
    description: '手机、平板、电脑无缝切换，一个账号全平台通用。通勤路上用手机，回家用电视投屏，在线观看从未如此自由。'
  },
  {
    icon: 'ri-4k-line',
    title: '4K超清画质',
    description: '最高支持4K HDR画质在线观看，杜比全景声沉浸音效。智能码率自适应技术，根据网络状况自动匹配最佳清晰度。'
  },
  {
    icon: 'ri-speed-up-line',
    title: '超低延迟播放',
    description: '全球CDN加速节点覆盖，国内主要城市延迟低于50ms。智能P2P传输技术加持，高峰期在线观看依然流畅不卡顿。'
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '无需下载安装',
    description: '纯网页端在线观看，打开浏览器即看即走。不占手机内存，无需更新App，真正的轻量化在线观看体验。'
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版内容保障',
    description: '与国内外多家内容制作方深度合作，所有内容均为正版授权。放心在线观看，支持创作者，享受高品质内容生态。'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，任何问题即时响应。电话、邮件、在线客服多渠道支持，让每一次在线观看都无忧。'
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
            极速高清在线观看的
            <span className="text-primary-500">六大优势</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            我们致力于为用户提供最流畅、最清晰、最便捷的在线观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-950 mb-2.5">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;